import React, { useState } from "react";
import {
  LuArrowLeftRight,
  LuInfo,
  LuShield,
  LuUser,
  LuUserCog,
  LuUsers,
} from "react-icons/lu";
import "../../assets/styles/logistics_rfq_super_admin_notice.scss";

const DETAIL_ITEMS = [
  "Logistics Managers are responsible for handling and monitoring Business Relocation and Exhibition Logistics RFQs.",
  "Logistics Managers can create and manage Logistics Users under their team.",
  "RFQs can be handled either directly by the Logistics Manager or by Logistics Users assigned under that manager.",
  "Super Admin can monitor all RFQs but day-to-day RFQ processing should be performed by the Logistics Manager and their team.",
];

const PANEL_ITEMS = [
  {
    icon: LuUser,
    title: "Create Logistics Manager",
    description: "Create a Logistics Manager role and assign users to that role.",
  },
  {
    icon: LuUsers,
    title: "Manager Responsibilities",
    description:
      "Logistics Managers are responsible for handling and monitoring Business Relocation and Exhibition Logistics RFQs.",
  },
  {
    icon: LuUserCog,
    title: "Manage Your Team",
    description: "Logistics Managers can create and manage Logistics Users under their team.",
  },
  {
    icon: LuArrowLeftRight,
    title: "RFQ Handling",
    description:
      "RFQs can be handled either directly by the Logistics Manager or by Logistics Users assigned under that manager.",
  },
  {
    icon: LuShield,
    title: "Super Admin Visibility",
    description:
      "Super Admin can monitor all RFQs but day-to-day RFQ processing should be performed by the Logistics Manager and their team.",
  },
];

export default function LogisticsRfqSuperAdminNotice({ show = false, variant = "full" }) {
  const [expanded, setExpanded] = useState(false);

  if (!show) return null;

  const isCompact = variant === "compact";
  const isPanel = variant === "panel";

  if (isPanel) {
    return (
      <section
        className={`sa-logistics-rfq-notice sa-logistics-rfq-notice--panel${
          expanded ? " sa-logistics-rfq-notice--panel-expanded" : ""
        }`}
        role="note"
        aria-labelledby="sa-logistics-rfq-notice-title"
      >
        <div className="sa-logistics-rfq-notice__panel-head">
          <div className="sa-logistics-rfq-notice__panel-head-main">
            <span className="sa-logistics-rfq-notice__panel-icon" aria-hidden>
              <LuInfo />
            </span>
            <h2 id="sa-logistics-rfq-notice-title">Logistics Management Notice</h2>
          </div>
          <button
            type="button"
            className="sa-logistics-rfq-notice__learn-more"
            onClick={() => setExpanded((prev) => !prev)}
            aria-expanded={expanded}
            aria-controls="sa-logistics-rfq-notice-panel-details"
          >
            {expanded ? "Show less" : "Learn more"}
          </button>
        </div>

        {expanded ? (
          <div id="sa-logistics-rfq-notice-panel-details" className="sa-logistics-rfq-notice__panel-grid">
            {PANEL_ITEMS.map((item, index) => {
              const Icon = item.icon;
              return (
                <article
                  key={item.title}
                  className={`sa-logistics-rfq-notice__panel-item${
                    index < PANEL_ITEMS.length - 1
                      ? " sa-logistics-rfq-notice__panel-item--divider"
                      : ""
                  }`}
                >
                  <span className="sa-logistics-rfq-notice__panel-item-icon" aria-hidden>
                    <Icon />
                  </span>
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </article>
              );
            })}
          </div>
        ) : null}
      </section>
    );
  }

  return (
    <aside
      className={`sa-logistics-rfq-notice${isCompact ? " sa-logistics-rfq-notice--compact" : ""}${
        expanded ? " sa-logistics-rfq-notice--expanded" : ""
      }`}
      role="note"
      aria-labelledby="sa-logistics-rfq-notice-title"
    >
      <span className="sa-logistics-rfq-notice__icon" aria-hidden>
        <LuInfo />
      </span>
      <div className="sa-logistics-rfq-notice__content">
        <div className="sa-logistics-rfq-notice__head">
          <div>
            <h2 id="sa-logistics-rfq-notice-title">Logistics Management Notice</h2>
            <p>
              To manage Logistics RFQs efficiently, please create a Logistics Manager role and assign
              users to that role.
            </p>
          </div>
          {isCompact ? (
            <button
              type="button"
              className="sa-logistics-rfq-notice__learn-more"
              onClick={() => setExpanded((prev) => !prev)}
              aria-expanded={expanded}
            >
              {expanded ? "Show Less" : "Learn More"}
            </button>
          ) : null}
        </div>
        {(!isCompact || expanded) && (
          <ul>
            {DETAIL_ITEMS.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        )}
      </div>
    </aside>
  );
}
